import React from "react";
import { useSelector } from "react-redux";
import OutlinerItem from "../../Outliner/OutlinerItem";
import BackgroundIcon from "@material-ui/icons/Landscape";
import { Typography } from "@material-ui/core";
import { setRedirect } from "../../Utility/Redirect/hooks";
import { withRouter } from "react-router";

function BackgroundOutliner(props) {
  const sessionIds = useSelector(state => state.session.sessionIds);
  const projectId = sessionIds ? sessionIds.projectId : null;

  const url = `/project/${projectId}/backgrounds`;

  return (
    <div>
      <OutlinerItem
        onClick={() => {
          setRedirect({ to: url });
        }}
        selected={props.match.url === url}
        selectable={true}
      >
        <BackgroundIcon />
        <Typography className="outliner-text">Backgrounds</Typography>
      </OutlinerItem>
    </div>
  );
}

export default withRouter(BackgroundOutliner);
